// extracted by mini-css-extract-plugin
export default {"crossButton":"ModalMembershipValidation_crossButton__qbF5u","modal":"ModalMembershipValidation_modal__q5ePB"};